import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useUserContext } from '../contexts/UserContext';
import { useIsImpersonating, returnToAdmin } from '../hooks/useImpersonation';

const ImpersonationBanner = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const isImpersonating = useIsImpersonating();
    const { user, logout } = useUserContext();
    const [isReturning, setIsReturning] = useState(false);

    if (!isImpersonating) return null;

    const handleReturn = async () => {
        setIsReturning(true);
        try {
            const backToAdmin = await returnToAdmin(logout);
            navigate(backToAdmin ? '/dashboard/admin/users' : '/login', { replace: true });
        } finally {
            setIsReturning(false);
        }
    };

    return (
        <div className="w-full bg-warning text-black text-sm font-semibold flex items-center justify-center gap-4 py-2 px-4">
            <span>{t('impersonation.banner', { email: user?.email || '' })}</span>
            <button type="button" className="btn btn-sm btn-dark" onClick={handleReturn} disabled={isReturning}>
                {t('impersonation.return_to_admin')}
            </button>
        </div>
    );
};

export default ImpersonationBanner;
